var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.frame) ? _c('div', {
    staticStyle: {
      "border-radius": "3px"
    },
    style: (_vm.wrStyle)
  }, _vm._l((_vm.frame), function(it, index) {
    return (it.visible) ? _c('div', {
      key: it[_vm.idProp],
      staticStyle: {
        "display": "inline-table",
        "position": "relative"
      },
      style: ([index == _vm.frame.length - 1 ? _vm.wLast : _vm.wPerc])
    }, [_c('div', {
      staticClass: "step",
      class: {
        'right-borderless': it[_vm.idProp] == _vm.last, 'left-borderless': it[_vm.idProp] == _vm.first
      },
      style: ([_vm.defaultStyle, _vm.active == it[_vm.idProp] ? _vm.activeStyle : _vm.active > it[_vm.idProp] ? _vm.doneStyle : _vm.todoStyle])
    }, [_vm._v("\n            " + _vm._s(_vm.showed(it)) + "\n            "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "grid"
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "smaller",
        "font-weight": "350",
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "max-width": "95%"
      }
    }, [_vm._v(_vm._s(_vm.showedValue(it)))])])]), _vm._v(" "), (it[_vm.idProp] != _vm.last) ? _c('div', {
      staticClass: "arrow",
      style: ([_vm.active == _vm.frame[index + 1][_vm.idProp] ? _vm.activeStyle : _vm.active > _vm.frame[index + 1][_vm.idProp] ? _vm.doneStyle : _vm.todoStyle])
    }) : _vm._e(), _vm._v(" "), (it[_vm.idProp] != _vm.last) ? _c('div', {
      staticClass: "over_arrow",
      style: ([_vm.active == it[_vm.idProp] ? _vm.borderActive : _vm.active > it[_vm.idProp] ? _vm.borderDone : _vm.borderTodo])
    }) : _vm._e()]) : _vm._e()
  })) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-224530ed","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/DynSteps.vue
// module id = 1468
// module chunks = 1